module.exports = [{
      plugin: require('../.yarn/$$virtual/gatsby-plugin-segment-js-virtual-197e7610fb/0/cache/gatsby-plugin-segment-js-npm-3.6.1-b62230ebc4-f08983797d.zip/node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"21RVKR9mDhzcF9pJ5iyh43SMfBY4nuQ2","devKey":"wCe3zjXbOGJiLowEiz1rJbh9V8le65Nd","trackPage":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
